import Rectangle from "@/assets/images/Rectangle";

const Play = () => {
  return (
    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[45px] h-[45px] bg-[#03071299] flex items-center pl-[17px] rounded-full z-30">
      <Rectangle />
    </div>
  );
};

export default Play;
